import { render, staticRenderFns } from "./addcomment.vue?vue&type=template&id=4087dfc8&scoped=true"
import script from "./addcomment.vue?vue&type=script&lang=js"
export * from "./addcomment.vue?vue&type=script&lang=js"
import style0 from "./addcomment.vue?vue&type=style&index=0&id=4087dfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087dfc8",
  null
  
)

export default component.exports